﻿import { LoginForm, LoginRequest } from "@/ServerTypes/Main";
import { PropertyPanel, localText, ErrorHandling, isEmptyOrNull, notifyWarning, alertDialog, parseQueryString, resolveUrl, serviceCall, ServiceResponse } from "@serenity-is/corelib";

$(function () {
    var loginPanel = new LoginPanel($('#LoginPanel')).init();
    loginPanel["byId"]('UserNo').attr("inputmode", "numeric").attr("pattern", "[1-9][0-9]{6}");
    loginPanel["byId"]('UserNo').focus();
    $(".caption>*").html("");

    $(".captcha_close").click(() => {
        $(".page-content").removeClass("unclickable");
    });

    $('#' + loginPanel["byId"]('UserNo').attr("id")).on('input', function (e) {
        let ipt_UserNo = $(this); let oldVal = ipt_UserNo.val();
        //@ts-ignore
        let newVal = oldVal.replace(/[^0-9]/g, '');
        if (oldVal !== newVal) {
            notifyWarning('请输入7位数字用户编号');
        }
        newVal = newVal.slice(0, 7);
        newVal = newVal.replace(/^0+/, '');
        ipt_UserNo.val(newVal);
    });
});


class LoginPanel extends PropertyPanel<LoginRequest, any> {

    protected getFormKey() { return LoginForm.formKey; }

    constructor(props: any) {
        super(props);

        this.byId('LoginButton').click(e => {
            e.preventDefault();

            if (!this.validateForm())
                return;

            $(".captcha_panel").removeAttr("hidden");
            $(".page-content").addClass("unclickable");
            if ($(".captcha_message_text").html() === "验证通过") {
                //当验证使用通过后,再次刷新
                var element = document.querySelectorAll('.captcha_action')[0];
                var event = new MouseEvent('click', { 'view': window, 'bubbles': true, 'cancelable': true });
                element.dispatchEvent(event);
            }
        });

        $('#SecSubmit').click(() => {
            setTimeout(() => {
                const CapRequestId = { CapRequestId: $("#CaptchaRequestId").html() };
                const CapsubData = { CapTrack: JSON.parse($("#CaptchasubData").html()) };
                const formData = this.getSaveEntity();
                const request = { ...formData, ...CapRequestId, ...CapsubData };

                this.byId('LoginButton').attr("disabled", "disabled");
                this.byId('LoginButton').empty();
                this.byId('LoginButton').append(<span><i class="fa fa-pulse fa-spinner"></i> 登录中..</span>);
                var IsPersistent = $("#LoginPanel0_IsPersistent").is(':checked');
                serviceCall({
                    url: resolveUrl('~/Account/Login?IsPersistent=' + IsPersistent),
                    request: request,
                    onSuccess: (response: ServiceResponse) => {
                        //@ts-ignore
                        if (response != null && response.CustomData != null && response.CustomData.logfail != null) {
                            this.byId('LoginButton').removeAttr("disabled");
                            this.byId('LoginButton').empty();
                            this.byId('LoginButton').append("登录");
                            //@ts-ignore
                            alertDialog(response.CustomData.logfail);
                            $(".s-AlertDialog .btn-danger").on("click", () => { this.byId('Password').focus(); });
                            return;
                        } else {
                            this.redirectToReturnUrl();
                        }
                    },
                    onError: (response: ServiceResponse) => {
                        if (response != null && response.Error != null && !isEmptyOrNull(response.Error.Message)) {
                            this.byId('LoginButton').removeAttr("disabled");
                            this.byId('LoginButton').empty();
                            this.byId('LoginButton').append("登录");
                            return;
                        }
                        ErrorHandling.showServiceError(response.Error);
                    }
                });
            });
        });
    }

    protected redirectToReturnUrl() {
        var q = parseQueryString();
        var returnUrl = q['returnUrl'] || q['ReturnUrl'];
        if (returnUrl) {
            var hash = window.location.hash;
            if (hash != null && hash != '#')
                returnUrl += hash;
            window.location.href = returnUrl;
        }
        else {
            window.location.href = resolveUrl('~/');
        }
    }

    protected getTemplate() {
        return `
<div class="flex-layout">
    <div class="logo"></div>
        <h3>${localText("Forms.Main.Login.FormTitle")}</h3>
    <form id="~_Form" action="">
        <div class="s-Form">
            <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                <div id="~_PropertyGrid"></div>
                <div class="clear"></div>
            </div>
            <div class="buttons">
                <button id="~_LoginButton" type="submit" class="btn btn-success">登 录</button>
                <button id="SecSubmit" hidden="hidden"></button>
                <div class="field IsPersistent">
                    <label class="caption"></label>
                    <div class="checkbox">
                        <label>
                            <input id="LoginPanel0_IsPersistent" name="IsPersistent" type="checkbox" class="s-BooleanEditor" /><span>十天内免登陆</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
`;
    }
}